var _objectSpread = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread");

var _require = require('../primitives'),
    STRING = _require.STRING;

var string = _objectSpread({}, STRING);

module.exports = string;